import type { SxProps, Theme } from '@mui/material';

import { IllustrationWrapper } from '../IllustrationWrapper';

import { AddFilesIllustration } from './AddFiles';

interface Props {
  readonly sx?: SxProps<Theme>;
  readonly title?: string;
}

export const AddFiles = ({ sx, title }: Readonly<Props>) => (
  <IllustrationWrapper sx={sx}>
    <AddFilesIllustration title={title} />
  </IllustrationWrapper>
);
